import { Navigate } from 'react-router-dom';

import { useEntitlements } from '@core/access';
import { useRoleDefault } from '@core/settings/useSettings';
import { Loading } from '@ui/Loading';

/**
 * Where `/` sends a signed-in user: their role's landing page from Settings >
 * Preferences, else Home.
 *
 * Waits for sign-in to resolve, because the roles that choose the page arrive
 * after the first render. A landing page the user cannot open (its flag is
 * off, or their role lacks it) answers 404 through that route's own guard,
 * so Settings offers only routes with guards in front of them.
 */
export function LandingRedirect() {
  const entitlements = useEntitlements();
  const { landing } = useRoleDefault();

  if (entitlements.pending) {
    return <Loading variant="page" label="Loading" />;
  }

  return <Navigate to={landing && landing.startsWith('/') ? landing : '/home'} replace />;
}
